export default {
  getHead: () => {
    return [{name: '회사명'}, {name: '성명'}, {name: '성별'}, {name: '발생날짜'}, {name: '재해형태'}, {name: '작성자'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.onNameBlur(func.getContent(value).inputC_1) // 성명
      case 2: return func.getContent(value).inputC_3 // 성별
      case 3: return func.getContent(value).inputD_1 // 발생날짜
      case 4: return func.getContent(value).inputD_5// 재해형태
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.inputD_5*[:default_disaster]')

    switch (nav.value.searchType) {
    case '회사명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '성명': returnData.push('content$body.inputC_1*%[:default_skw]%'); break
    case '성별': returnData.push('content$body.inputC_3*%[:default_skw]%'); break
    case '발생날짜': returnData.push('content$body.inputD_1*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
